import debug from 'debug';
import BaseComponent from 'Global/Shared/Components/BaseComponent/BaseComponent';

const log = debug('ProductPagesTopSearches');

class ProductPagesTopSearches extends BaseComponent {
	constructor(element) {
		super(element);

		this.initialize();
	}


	initialize() {
		this.initDomCache();
	
	}
}

export default ProductPagesTopSearches;
